import { css, cx } from "@emotion/css";
import type { ReactNode } from "react";
import { useState, createRef } from "react";
import { PopoverBasic, type PopoverBasicProps } from "./PopoverBasic";
export interface PopoverBasicWithTriggerProps extends Omit<PopoverBasicProps, "open" | "anchorEl"> {
    onOpen?: () => void;
    triggerElement: ReactNode;
    triggerAlignment?: "default" | "center";
    open?: boolean;
}
export function PopoverBasicWithTrigger({ onOpen, open, ...props }: PopoverBasicWithTriggerProps): JSX.Element {
    const [anchorEl, setAnchorEl] = useState<null | HTMLDivElement>(null);
    const ref = createRef<HTMLDivElement>();
    const handleTriggerElementClick = () => {
        anchorEl ? handleClose() : handleOpen();
    };
    const handleOpen = () => {
        setAnchorEl(ref.current);
        onOpen?.();
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    return (<div ref={ref} className={styles.popoverandElement}>
            <div onClick={handleTriggerElementClick} className={cx(styles.triggerElementWrapper, { [styles.triggerElementCenter]: props.triggerAlignment === "center" })}>
                {props.triggerElement}
            </div>
            <PopoverBasic onClose={handleClose} anchorEl={anchorEl} open={open === undefined ? !!anchorEl : open} {...props}/>
        </div>);
}
const styles = {
    popoverandElement: css({
        display: "inline-block",
        maxWidth: "100%",
    }),
    triggerElementWrapper: css({
        "&>div": {
            cursor: "pointer",
        },
    }),
    triggerElementCenter: css({
        display: "flex",
        alignItems: "center",
    }),
};
